export const labelMenuSidebar = {
  Insurance: 'insurance', //Asuransi
  Managements: 'management', //Manajemen
  'Insurance Claim History': 'claim_history', //Riwayat Klaim
  'Claim Tpa': 'claim_tpa', //Klaim TPA
  'Buku Tarif': 'tarif_book', //Buku Tarif
  Role: 'role', //Hak Akses
  'Insurance Portal': 'app_insurance_portal', //Portal Asuransi
  User: 'user', //Pengguna
  Company: 'menu_company', //Perusahaan
  Analytic: 'app_analytics_dashboard', //Dashboard Analitik
  // BE name of the `company-insurance-claim-qc-analytic` menu (SA-2118).
  'Insurance Claim QC Analytic': 'app_qc_analytics_dashboard', //Dashboard Analitik QC
  'Quality Checker': 'app_quality_checker', //Quality Checker (SA-1552)
};
